import OfficialStore from '../../../common/components/official-store/official-store.ui';
import { OFFICIAL_STORE_TYPES } from '../../../common/constants';

export default {
  [OFFICIAL_STORE_TYPES.OFFICIAL_STORE_LABEL]: {
    component: OfficialStore,
  },
};
